import React from 'react';
import PropTypes from 'prop-types';

import Mixed from './Mixed';

import Numerical from './Numerical';
import Categorical from './Categorical';

import DoubleNumerical from './DoubleNumerical';
import DoubleCategorical from './DoubleCategorical';

const BottomPaneComponent = ({
  isFirstParamNumerical,
  isFirstParamCategorical,
  isSecondParamNumerical,
  isSecondParamCategorical,
  secondParameterType,
  firstParameterName,
  secondParameterName,

  numericalName,
  categoricalName,

  isFrequencyTable,
  isTypeOfGraphsFrequencyBarChart,
  isTypeOfGraphsFrequencyPieChart,
  activeChartsAndGraphsTab
}) => {
  if (!secondParameterType) {
    return isFirstParamNumerical
      ? <Numerical parameter={firstParameterName} />
      : (
        <Categorical
          parameter={firstParameterName}
        />
      );
  }

  if (isFirstParamCategorical && isSecondParamCategorical) {
    const isTypeOfGraphsFrequency = activeChartsAndGraphsTab === 4 ? isTypeOfGraphsFrequencyBarChart : isTypeOfGraphsFrequencyPieChart;
    return (
      <DoubleCategorical
        firstParameter={firstParameterName}
        secondParameter={secondParameterName}
        isFrequencyTable={isFrequencyTable}
        isTypeOfGraphsFrequency={isTypeOfGraphsFrequency}
      />
    );
  }

  if (isFirstParamNumerical && isSecondParamNumerical) {
    return (
      <DoubleNumerical
        firstParameter={firstParameterName}
        secondParameter={secondParameterName}
      />
    );
  }
  return (
    <Mixed
      numericalParameter={numericalName}
      categoricalParameter={categoricalName}
    />
  );
};

BottomPaneComponent.propTypes = {
  isFirstParamNumerical: PropTypes.bool,
  isFirstParamCategorical: PropTypes.bool,
  isSecondParamNumerical: PropTypes.bool,
  isSecondParamCategorical: PropTypes.bool,
  secondParameterType: PropTypes.string,
  firstParameterName: PropTypes.string,
  secondParameterName: PropTypes.string,

  numericalName: PropTypes.string,
  categoricalName: PropTypes.string,

  isFrequencyTable: PropTypes.bool,
  isTypeOfGraphsFrequencyBarChart: PropTypes.bool.isRequired,
  isTypeOfGraphsFrequencyPieChart: PropTypes.bool.isRequired,
  activeChartsAndGraphsTab: PropTypes.number.isRequired
};

export default BottomPaneComponent;
